import { FC, ReactNode } from 'react'
import { FormItem, FormItemType } from './editor/FormItem'
import { ItemsLibrary, ItemsLibraryType } from './editor/ItemsLibrary'
import { ItemsWrapper, ItemsWrapperType } from './editor/ItemsWrapper'
import { PageTitle, PageTitleType } from './editor/PageTitle'
import { Preview, PreviewType } from './editor/Preview'
import { Tabs, TabsType } from './editor/Tabs'
import { EditorWrapper, EditorWrapperType } from './editor/Wrapper'
import { FormTag, FormTagType } from './Tag'

import {
  FormItemOptionEditor,
  FormItemOptionEditorType,
} from './editor/FormItemOptionEditor'
import { Form as FormForm, FormType as FormFormType } from './form/Form'

export const Form: FC &
  EditorWrapperType &
  PageTitleType &
  ItemsWrapperType &
  ItemsLibraryType &
  FormItemType &
  PreviewType &
  FormItemOptionEditorType &
  TabsType &
  FormTagType &
  FormFormType = (): ReactNode => <></>

Form.Wrapper = EditorWrapper
Form.PageTitle = PageTitle
Form.Tabs = Tabs
Form.ItemsWrapper = ItemsWrapper
Form.ItemsLibrary = ItemsLibrary
Form.FormItem = FormItem
Form.Preview = Preview
Form.ItemOptionEditor = FormItemOptionEditor
Form.Tag = FormTag

Form.Form = FormForm
